// Compiled at 2026-09-18T12:45:23.821Z
// Auto-generated by Lowgile
import { unwrapReadonly, assignCommonProperties, coerceDataType, createReadonlyProxy } from "@lg/shared/for-apps";
import * as Ramda from "ramda";
import * as $Modules from "../../Module/$modules.js";
import { System, System as This } from "../../Module/$modules.js";
import type { HasId, IdType, Class, DeepReadonly, NominalType } from "@lg/shared";
import { Sys, ExecutionService } from "@lg/ng-shared";
import { jsonClass } from "@sumbricht/json-class-serializer";

const cache = new Map<string, any>();

export class $Config {
    static get Security() {
        return {
            'allowRegisteringUsers': false
        }
    }

    static get PasswordPolicy() {
        return {
            'minimumLength': 8,
            'mustContainUpperCaseLetters': 1,
            'mustContainLowerCaseLetters': 1,
            'mustContainSymbols': 1,
            'mustContainDigits': 1,
            'mustMatchRegex': ''
        }
    }

    static get Logging() {
        return {
            'logLevel': 'info',
            'logSqlQueriesSlowerThanMs': 250,
            'raiseIssueForSqlQueriesSlowerThanMs': 1000,
            'logSqlQueriesWithErrors': true
        }
    }

    static get Environment() {
        return {
            'type': 'PROD',
            'publicName': '',
            'shortName': '',
            'color': '#1e88e5',
            'publicUrl': ''
        }
    }
}
